import { e$2, n$2, t$2 } from '@/js/global/global'
import { getMediaQuery } from '@/js/global/helpers'

const selectors$h = {
  playButton: "[data-play-button-block]",
  playButtonVideoContainer: "[data-play-button-block-video-container]",
  photoSwipeElement: ".pswp",
  video: "[js-data-block-video]"
};

const {
  icons
} = window.theme;

const playButton = node => {
  let photoSwipeInstance;

  const playButton = n$2(selectors$h.playButton, node);
  const videoHtml = n$2(selectors$h.playButtonVideoContainer, node).outerHTML;

  const handleVideoPlayers = (videos, resize = false) => {
    let mobileVideo;
    let desktopVideo;

    videos.forEach(video => {
      if (video.classList.contains('play-button-block-video--mobile')) {
        mobileVideo = video;
      }

      if (video.classList.contains('play-button-block-video--desktop')) {
        desktopVideo = video;
      }
    });

    if (window.matchMedia(getMediaQuery("below-720")).matches) {
      if (mobileVideo) {
        if (resize) {
          if (desktopVideo && !desktopVideo.paused) {
            desktopVideo.pause();
          }

          if (mobileVideo.paused) mobileVideo.play();
          console.log("Is Mobile: Stop desktop");
        } else {
          if (mobileVideo.paused) mobileVideo.play();
        }
      }
    }

    if (window.matchMedia(getMediaQuery("above-720")).matches) {
      if (desktopVideo) {
        if (resize) {
          if (mobileVideo && !mobileVideo.paused) {
            mobileVideo.pause();
          }

          if (desktopVideo.paused) desktopVideo.play();
        } else {
          if (desktopVideo.paused) desktopVideo.play();
        }
      }
    }
  }

  import('@/js/vendor/photoswipe-chunk'); // Load this ahead of needing

  const events = [
    e$2(playButton, "click", () => {
      import('@/js/vendor/photoswipe-chunk').then(_ref => {
        let {
          PhotoSwipeLightbox,
          PhotoSwipe
        } = _ref;

        photoSwipeInstance = new PhotoSwipeLightbox({
          dataSource: [{
            html: videoHtml
          }],
          pswpModule: PhotoSwipe,
          mainClass: "pswp--video-lightbox",
          closeSVG: icons.close,
          arrowPrev: false,
          arrowNext: false,
          zoom: false,
          counter: false
        });

        photoSwipeInstance.init();
        photoSwipeInstance.loadAndOpen();
        photoSwipeInstance.on("bindEvents", () => {
          const videos = t$2(selectors$h.video, photoSwipeInstance.pswp.container);

          handleVideoPlayers(videos);

          window.addEventListener('resize', () => {
            setTimeout(() => {
              photoSwipeInstance.destroy();
            }, 1000);
          });
        });
      });
    })
  ];

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());

    photoSwipeInstance && photoSwipeInstance.destroy();
  };

  return {
    unload
  };
};

const autoPlay = videos => {
  if (!videos.length) return;

  const events = [
    e$2(window, "click", () => _handleAutoPlay()),
    e$2(window, "touchstart", () => _handleAutoPlay())
  ];

  // Force autoplay after device interaction if in low power mode
  function _handleAutoPlay() {
    videos.forEach(video => {
      if (!video.playing) {
        video.play();
      }
    });

    events.forEach(unsubscribe => unsubscribe());
  }
};

export { playButton, autoPlay }